import { type UserConfig, load, getDefaultConfig } from './config/config';
import { LoggerFactory } from './logger/logger-factory';
import type { ID } from './protocol/protocol';
import { Session } from './session/session';
import { SessionFactory } from './session/session-factory';

export class CloserSDK {

    public static init(userConfig?: UserConfig): CloserSDK {
        const config = typeof userConfig !== 'undefined' ? load(userConfig) : getDefaultConfig();
        const loggerFactory = new LoggerFactory(config.logLevel);
        const logger = loggerFactory.create(`CloserSDK`);

        logger.debug(`Received user configuration: ${JSON.stringify(userConfig)}`);
        logger.debug(`Initializing with configuration: ${JSON.stringify(config)}`);

        return new CloserSDK(new SessionFactory(config, loggerFactory));
    }

    public withSession(id: ID): Session {
        return this.sessionFactory.create(id);
    }

    private constructor(
        private sessionFactory: SessionFactory
    ) { }
}
